<template>
  <div
    :class="`mt-${mt}`"
    class="smsc-col__item flex-grow-0"
    :style="{ 'flex-basis': `${100 / colQuantity}%` }"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'smsc-col-item',
  props: {
    'col-quantity': {
      type: Number,
      default: 3
    },
    'mt':{
      type: Number,
      default: 6
    }
  }
}
</script>

